export default {
  userList: (state) => state.userList,
  userCount: (state) => state.userCount,
  userDetail: (state) => state.userDetail,
  userCountSearch: (state) => state.userCountSearch,
  userActivities: (state) => state.userActivities,
};
